import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Platform } from '@ionic/angular';
import { PagesPage } from './pages/pages.page';
import { LocaleService } from './i18n/locale.service';

@Component({
  standalone: false,
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit{

    constructor(
        private zone: NgZone,
        private platform: Platform,
        private router: Router,
        private locale: LocaleService
    ) {
        this.locale.initialize();
        this.initializeApp();
    }

    ngOnInit(): void {
        this.platform.ready().then(() => {
            if(Capacitor.isNativePlatform()){
                // StatusBar.setOverlaysWebView({ overlay: false });
				if(Capacitor.getPlatform() != 'ios'){
                	StatusBar.setStyle({style: Style.Dark});
                	StatusBar.setBackgroundColor({color: '#DA2128'});
				}
            }

            // TESTE PLANTA
            // this.router.navigate(['/planta/1'], {queryParams: {signature: 'd3a7e6a633eb1eca4552a64ab362420875aa6254fed8c1a6e3f219a1181e5080'}})

        })
    }

    initializeApp(){
        App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
            this.zone.run(() => {
                // Example url: https://e-brigada.com.br/atividade
                // slug = /atividade
                let slug = event.url.split(".br").pop()?.replace('admin/', '');
                if (slug) {
                    if(slug.indexOf('files') != -1){
                        this.platform.ready().then(() => {
                            PagesPage.download(event.url);
                            this.router.navigateByUrl('/');
                        });
                    }else{
                        if(slug.indexOf('login') != -1)
                            slug = '/';
                        //Se é a Lista de presença da ata enviar para a rota publica
                        else if(slug.indexOf('ata') != -1 && slug.indexOf('presenca') != -1 && slug.indexOf('signature') != -1){
                            slug = slug.replace('ata', 'ata-presenca');
                        }
                        //Se é a pagina de verificar a atividade/inspecao enviar para a rota publica
                        else if(slug.indexOf('atividade') != -1 && slug.indexOf('check') != -1 && slug.indexOf('signature') != -1)
                            slug = slug.replace('atividade', 'inspecao');
                        this.router.navigateByUrl(slug);
                    }
                }
                // If no match, do nothing - let regular routing
                // logic take over
            });
        });
    }
}
